import { ApiProperty } from "@nestjs/swagger";
import { IsAlphanumeric, IsNotEmpty, IsNumber, IsOptional } from "class-validator";

export class QaQcTestIdRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    qaQcTestId: number;

    @ApiProperty()
    @IsOptional()
    updatedUser?: string;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    versionFlag?: number;

    @ApiProperty()
    isActive?: boolean;
}